import React, { useEffect, useState } from "react";
import { api } from "../utils/api";
import { useApp } from "../context/AppContext";
import { t } from "../utils/i18n";
import { TrendingUp } from "lucide-react";

// Statistiques d'une campagne — propriétaire uniquement (GET /sponsorships/:id/stats). Le CTR
// est calculé côté client, aucune raison de le stocker/recalculer serveur.
export default function AdPerformance() {
  const { lang } = useApp();
  const [items, setItems] = useState<any[]>([]);
  const [stats, setStats] = useState<Record<string, { impressions: number; clicks: number } | null>>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/sponsorships/me").then(data => {
      const list = data?.sponsorships || [];
      setItems(list);
      list.forEach((s: any) => {
        api.get(`/sponsorships/${s.id}/stats`).then(d => setStats(prev => ({ ...prev, [s.id]: d?.impressions != null ? d : null }))).catch(() => {});
      });
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) return <div style={{ textAlign: "center", padding: 40, color: "#999" }}>Chargement…</div>;
  if (items.length === 0) {
    return (
      <div style={{ textAlign: "center", padding: "40px 20px", color: "#999" }}>
        <TrendingUp size={36} strokeWidth={1.5} color="#ccc" style={{ marginBottom: 10 }} />
        <div style={{ fontSize: 14 }}>{t(lang, "ad_tool_no_campaigns")}</div>
      </div>
    );
  }

  return (
    <div>
      {items.map(s => {
        const st = stats[s.id];
        const ctr = st && st.impressions > 0 ? ((st.clicks / st.impressions) * 100).toFixed(1) : null;
        return (
          <div key={s.id} style={{ backgroundColor: "white", borderRadius: 16, padding: 18, marginBottom: 12, border: "1px solid #F0F0F0" }}>
            <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 10 }}>{s.target_label || "Campagne"}</div>
            <div style={{ display: "flex", gap: 20 }}>
              <div>
                <div style={{ fontSize: 20, fontWeight: 800 }}>{st ? st.impressions : "—"}</div>
                <div style={{ fontSize: 11, color: "#999" }}>{t(lang, "ad_tool_performance_impressions")}</div>
              </div>
              <div>
                <div style={{ fontSize: 20, fontWeight: 800 }}>{st ? st.clicks : "—"}</div>
                <div style={{ fontSize: 11, color: "#999" }}>{t(lang, "ad_tool_performance_clicks")}</div>
              </div>
              <div>
                <div style={{ fontSize: 20, fontWeight: 800 }}>{ctr != null ? `${ctr}%` : "—"}</div>
                <div style={{ fontSize: 11, color: "#999" }}>{t(lang, "ad_tool_performance_ctr")}</div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
